import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.ShipmentsFulfillmentsPage',
    defaultMessage: 'Shipments > Fulfillments',
    id: 'tw34ls',
  },
});

export const hotkey = ['g', 'f'];
export const barcodeContent = '+QV3MD9BNS55Q=';

const GotoShipmentsFulfillmentsPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push('/shipments/fulfillments'), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['gf'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoShipmentsFulfillmentsPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoShipmentsFulfillmentsPage;
